/**
 * State Manager Module
 * Quản lý trạng thái global của ứng dụng
 */

// Global state variables
let selectedCourses = [];
let coursesData = [];
let recentlyViewedData = [];
let discountPercent = 0;
let sourceTracking = {};
let campaignsCache = null;
let currentCampaignsTotal = 0;
let currentCampaignsItemCount = 0;
let selectedCampaignId = null;
let freeCoursesDiscount = 0;

// Timeout variables
let saveStorageTimeout = null;
let checkCustomerTimeout = null;
let campaignLoadTimeout = null;

// DOM Cache
const $cache = {
    phone: null,
    name: null,
    email: null,
    note: null,
    selectedCourses: null,
    subtotalAmount: null,
    discountAmount: null,
    discountRow: null,
    totalAmount: null,
    phoneError: null,
    discountCampaignName: null,
    emptyState: null,
    registrationSection: null,
    paymentSummarySection: null
};

// Getters
export function getSelectedCourses() {
    return selectedCourses;
}

export function setSelectedCourses(courses) {
    selectedCourses = courses;
}

export function getCoursesData() {
    return coursesData;
}

export function setCoursesData(data) {
    coursesData = data;
}

export function getRecentlyViewedData() {
    return recentlyViewedData;
}

export function setRecentlyViewedData(data) {
    recentlyViewedData = data;
}

export function getDiscountPercent() {
    return discountPercent;
}

export function setDiscountPercent(percent) {
    discountPercent = percent;
}

export function getSourceTracking() {
    return sourceTracking;
}

export function setSourceTracking(tracking) {
    sourceTracking = tracking;
}

export function getCampaignsCache() {
    return campaignsCache;
}

export function setCampaignsCache(cache) {
    campaignsCache = cache;
}

export function getCurrentCampaignsTotal() {
    return currentCampaignsTotal;
}

export function setCurrentCampaignsTotal(total) {
    currentCampaignsTotal = total;
}

export function getCurrentCampaignsItemCount() {
    return currentCampaignsItemCount;
}

export function setCurrentCampaignsItemCount(count) {
    currentCampaignsItemCount = count;
}

export function getSelectedCampaignId() {
    return selectedCampaignId;
}

export function setSelectedCampaignId(id) {
    selectedCampaignId = id;
}

export function getFreeCoursesDiscount() {
    return freeCoursesDiscount;
}

export function setFreeCoursesDiscount(discount) {
    freeCoursesDiscount = discount;
}

// Timeout getters/setters
export function getSaveStorageTimeout() {
    return saveStorageTimeout;
}

export function setSaveStorageTimeout(timeout) {
    saveStorageTimeout = timeout;
}

export function getCheckCustomerTimeout() {
    return checkCustomerTimeout;
}

export function setCheckCustomerTimeout(timeout) {
    checkCustomerTimeout = timeout;
}

export function getCampaignLoadTimeout() {
    return campaignLoadTimeout;
}

export function setCampaignLoadTimeout(timeout) {
    campaignLoadTimeout = timeout;
}

// DOM Cache getters
export function getCache() {
    return $cache;
}

export function initializeCache($) {
    $cache.phone = $('#ktvhvn-phone');
    $cache.name = $('#ktvhvn-name');
    $cache.email = $('#ktvhvn-email');
    $cache.note = $('#ktvhvn-note');
    $cache.selectedCourses = $('#ktvhvn-selected-courses');
    $cache.subtotalAmount = $('#ktvhvn-subtotal-amount');
    $cache.discountAmount = $('#ktvhvn-discount-amount');
    $cache.discountRow = $('#ktvhvn-discount-row');
    $cache.totalAmount = $('#ktvhvn-total-amount-top');
    $cache.phoneError = $('#ktvhvn-phone-error');
    $cache.discountCampaignName = $('#ktvhvn-discount-campaign-name');
    $cache.emptyState = $('#ktvhvn-empty-state');
    $cache.registrationSection = $('#ktvhvn-registration-section');
    $cache.paymentSummarySection = $('#ktvhvn-payment-summary-section');
}
